import { useEffect, useRef, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Link } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowWhiteIcon from '../../../assets/images/pages/privilege/arrow-white.png';
import ArrowIcon from '../../../assets/images/pages/privilege/arrow.png';
import { privilegeTypeEnum } from '../../../assets/js/utils';

const PrivilegeGroup = ({ topic, type, children, banner, index }) => {
  const [expanded, setExpanded] = useState(false);
  const ref = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const encodedId = encodeURIComponent(topic);

  const handleChange = (e, isExpanded) => {
    setExpanded(isExpanded);
    if (isExpanded) {
      navigate(`/privilege#${encodedId}`);
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    if (location.hash === `#${encodedId}`) {
      setExpanded(true);
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location.hash, encodedId]);

  return (
    <div ref={ref}>
      <Accordion
        expanded={expanded}
        onChange={handleChange}
        sx={{
          borderRadius: '20px !important',
          boxShadow: 'none',
          backgroundColor: 'transparent',
          '&::before': {
            display: 'none',
          },
          '&.Mui-expanded': {
            margin: '0',
          },
        }}
      >
        <AccordionSummary
          id={topic}
          aria-controls={`${topic}-content`}
          expandIcon={
            <Box
              component="img"
              src={index === 4 ? ArrowWhiteIcon : ArrowIcon}
              sx={{ width: '15px' }}
            />
          }
          sx={{
            padding: '0',
            position: 'relative',
            borderRadius: '20px !important',
            background: 'transparent',
            '&.Mui-expanded': {
              minHeight: 'unset',
            },
            '& .MuiAccordionSummary-expandIconWrapper': {
              position: 'absolute',
              right: '10px',
            },
            '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              transform: 'rotate(90deg)',
            },
            '& .MuiAccordionSummary-content.Mui-expanded': {
              margin: '12px 0',
            },
          }}
        >
          <Box
            component="img"
            src={banner}
            alt="banner"
            sx={{
              width: '100%',
            }}
          />
        </AccordionSummary>
        <AccordionDetails
          sx={{
            padding: '10px 0',
            backgroundColor: 'transparent',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
          }}
        >
          {type === privilegeTypeEnum.GROUP &&
            children.map((child, index) => {
              if (child.type === privilegeTypeEnum.CARD) {
                return (
                  <Link
                    key={index}
                    href={child.external_url}
                    target="_blank"
                    sx={{ position: 'relative' }}
                  >
                    <Box
                      component="img"
                      src={child.image_url}
                      alt="Privilege"
                      sx={{ width: '100%' }}
                    />
                    <Box
                      component="img"
                      src={ArrowIcon}
                      sx={{
                        width: '15px',
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                      }}
                    />
                  </Link>
                );
              }

              if (child.type === privilegeTypeEnum.GROUP) {
                return (
                  <Accordion key={index} sx={{ background: 'transparent', boxShadow: 'none' }}>
                    <AccordionSummary
                      id={child.topic}
                      expandIcon={<Box component="img" src={ArrowIcon} sx={{ width: '15px' }} />}
                      sx={{
                        padding: '0',
                        '& .MuiAccordionSummary-content': {
                          padding: '0',
                          margin: '0',
                        },
                        '& .MuiAccordionSummary-expandIconWrapper': {
                          position: 'absolute',
                          right: '10px',
                        },
                        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                          transform: 'rotate(90deg)',
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src={child.image_url}
                        alt="Privilege"
                        sx={{ width: '100%' }}
                      />
                    </AccordionSummary>
                    <AccordionDetails
                      sx={(theme) => ({
                        padding: '10px 0',
                        [theme.breakpoints.up('sm')]: { padding: '20px 0' },
                      })}
                    >
                      {child.data.map((item, idx) => (
                        <Link
                          key={idx}
                          href={item.external_url}
                          target="_blank"
                          sx={(theme) => ({
                            fontSize: '14px',
                            display: 'block',
                            backgroundColor: '#E7FBFF',
                            marginBottom: '10px',
                            borderRadius: '10px',
                            border: '2px solid white',
                            color: '#004B61',
                            padding: '5px',
                            [theme.breakpoints.up('sm')]: {
                              padding: '10px',
                              fontSize: '18px',
                              marginBottom: '20px',
                            },
                          })}
                        >
                          {item.topic}
                        </Link>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                );
              }

              return null;
            })}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default PrivilegeGroup;
